module.exports = __webpack_public_path__ + "img/testimonial2.277b4d4e.jpg";